import { render, staticRenderFns } from "./data73.vue?vue&type=template&id=258cb2aa&scoped=true&"
import script from "./data73.vue?vue&type=script&lang=js&"
export * from "./data73.vue?vue&type=script&lang=js&"
import style1 from "./data73.vue?vue&type=style&index=1&id=258cb2aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258cb2aa",
  null
  
)

export default component.exports